import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import WoffEmbeddedMixin from 'mixins/WoffEmbeddedMixin';

const WoffEmbeddedIcon = createReactClass({
  propTypes: {
    className: PropTypes.string,
    unicodeChar: PropTypes.string,
    iconSize: PropTypes.string,
  },

  mixins: [WoffEmbeddedMixin, PureRenderMixin],

  getDefaultProps() {
    return {
      className: null,
      unicodeChar: 'f000',
      iconSize: null,
    };
  },

  renderIcon() {
    const styles = {
      display: 'inline-block',
      fontFamily: `'${this._name}'`,
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontVariant: 'normal',
      fontStretch: 'normal',
      fontSize: this.props.iconSize,
      lineHeight: '1',
      textRendering: 'auto',
      WebkitFontSmoothing: 'antialiased',
    };

    return <i className={this.props.className} style={styles}>{String.fromCharCode(parseInt(this.props.unicodeChar, 16))}</i>;
  },

  render() {
    return (this.props.woff) ? this.renderIcon() : null;
  },
});

export default WoffEmbeddedIcon;



// WEBPACK FOOTER //
// ./app/javascript/components/WoffEmbeddedIcon.js